import React, { useState } from "react";
import "./App.css";
import { Header } from './components/Header';
import { FrameworkDiagram } from './components/FrameworkDiagram';
import { HooksGrid } from './components/HooksGrid';
import { HookDrawer } from './components/HookDrawer';
import { FrameworkInfo } from './components/FrameworkInfo';

function App() {
  const [activeComponent, setActiveComponent] = useState('setup');
  const [selectedHook, setSelectedHook] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleComponentSelect = (component) => {
    setActiveComponent(component);
  };

  const handleHookClick = (hook) => {
    setSelectedHook(hook);
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <div className="App">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1 className="hero-title">
                NodeBoot Test Framework
              </h1>
              <p className="hero-description">
                A comprehensive, extensible testing framework for NodeBoot applications with a hook-based architecture for dependency injection, service mocking, and lifecycle management.
              </p>
            </div>
          </div>
        </section>

        {/* Framework Diagram */}
        <section className="diagram-section" id="features">
          <div className="container">
            <FrameworkDiagram
              onComponentSelect={handleComponentSelect}
              activeComponent={activeComponent}
            />
          </div>
        </section>

        {/* Hooks Grid */}
        <section className="hooks-section" id="hooks">
          <div className="container">
            <HooksGrid
              activeComponent={activeComponent}
              onHookClick={handleHookClick}
            />
          </div>
        </section>

        {/* Framework Information */}
        <FrameworkInfo />

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-grid">
              <div className="footer-col">
                <h3 className="footer-title">NodeBoot Test Framework</h3>
                <p className="footer-text">
                  Built for developers who demand excellence in testing.
                </p>
              </div>
              <div className="footer-col">
                <h4 className="footer-heading">Resources</h4>
                <ul className="footer-links">
                  <li><a href="#docs">Documentation</a></li>
                  <li><a href="#examples">Examples</a></li>
                  <li><a href="#api">API Reference</a></li>
                </ul>
              </div>
              <div className="footer-col">
                <h4 className="footer-heading">Community</h4>
                <ul className="footer-links">
                  <li><a href="#github">GitHub</a></li>
                  <li><a href="#discord">Discord</a></li>
                  <li><a href="#twitter">Twitter</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-bottom">
              <p>© 2025 NodeBoot Test Framework. MIT License.</p>
            </div>
          </div>
        </footer>
      </main>

      {/* Hook Documentation Drawer */}
      <HookDrawer
        hook={selectedHook}
        isOpen={drawerOpen}
        onClose={handleDrawerClose}
      />
    </div>
  );
}

export default App;
